var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFireFeaturesPreviousBurntArea = function SvgFireFeaturesPreviousBurntArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    d: "M2 2.097h20v20H2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4.097h16v16H4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "M16.123 20.097h-5.657L4 13.631V7.974zM20 15.49v4.608h-1.049L4 5.146V4.097h4.608zm0-8.485v5.656l-8.563-8.563h5.657zm-.078-2.907H20v.078zM4 16.46l3.638 3.638H4z",
    clipRule: "evenodd"
  })));
};
export default SvgFireFeaturesPreviousBurntArea;